<template>
<nav>
    <ul class="navbar-links reveal" id="intro">
        <li id="about">
            <a href="/#" v-scroll-to="'.greo-container'" id="about">Greo</a>
        </li>

        <li id="about">
            <a href="/#" v-scroll-to="'.tldr-container'" id="team">TLDR</a>
        </li>

        <li id="about">
            <a href="/#" v-scroll-to="'.stashe-container'" id="poducts">Stashe</a>
        </li>

        <li id="about">
            <a href="/#" v-scroll-to="'.team-container'" id="contact">Team</a>
        </li>
    </ul>
</nav>
</template>

<script>
import Menu from './Menu.vue';

export default {

  name: 'Menu',
  components: {
	  Menu
  },
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

// MARK: - Generic Styles

.navbar-links {

	list-style-type: none;
  	display: flex;
    flex-direction: row;
    justify-content: center;
	flex: 1;
    padding: 0;


	li:last-child {
		margin-right: 0;
	}

	a { // TODO: Add underline animation
		text-decoration: none;
		color: #FFFFFF;
		text-transform: uppercase;

		font-weight: 300;
		letter-spacing: 0.3em;
		opacity: 0.7;

		padding-left: 0.5em;
		padding-right: 0.5em;

	}

    li {
        margin-right: 0.5em;
    }

	a:hover {
		opacity: 1;
	}
}

</style>



// WEBPACK FOOTER //
// src/components/Intro/Menu.vue